
export function startScrollTrigger() {
    
    document.querySelectorAll("[data-parallax]").forEach(el => {
        var y;
        var scale = 1;
        const options = {
            scrub: true,
            markers: false,
            toggleActions: "play none none reset",
            trigger: el.dataset.trigger ? el.dataset.trigger : el.parentElement,
        };
        if (el.dataset.from) {
            options.from = el.dataset.from;
        }
        if (el.dataset.start) {
            options.start = el.dataset.start;
        }
        if (el.dataset.end) {
            options.end = el.dataset.end;
        }
        if (el.dataset.pin) {
            options.pin = el.dataset.pin;
        }
        if (el.dataset.y) {
            y = el.dataset.y
        }
        if (el.dataset.scale) {
            scale = el.dataset.scale
        }
        if (el.dataset.markers) {
            options.markers = el.dataset.markers
        }
        if (el.dataset.speed) {
            options.speed = el.dataset.speed;
            y = (i, target) => ScrollTrigger.maxScroll(window) * target.dataset.speed
        }
        var anim = !el.dataset.from ? gsap.to : gsap.from;
        anim(el, {
            scrollTrigger: options,
            y: y,
            scale: scale,
            ease: "none"
        });
    });
    
    document.querySelectorAll('.module-textonimage__wrapper').forEach(el => {
    
    
        
        gsap.from(el, {
            scrollTrigger: {
                scrub: false,
                markers: false,
                toggleActions: "play none none reverse",
                trigger: el.closest('.module'),
                start: 'top center',
        
            },
            y: "+=50%",
            opacity: 0,
            delay: 0,
            duration: 1,
            ease: "power2.out"
        });
    
    });
    document.querySelectorAll('.module-textonimage__bg').forEach(el => {
    
    
        
        gsap.from(el, {
            scrollTrigger: {
                scrub: false,
                markers: false,
                toggleActions: "play none none reverse",
                trigger: el.closest('.module'),
                start: 'top center',
        
            },
            y: "+=80%",
            opacity: 0,
            duration: 2,
            delay: 0.2,
            ease: "power2.out"
        });
    
    });
}

